import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import './SplashScreen.css'

const SplashScreen = () => {

    const navigate = useNavigate()

    useEffect(() => {        
        setTimeout(() => {
            navigate('/auth/login')
        },3000)
    },[])

    return (
        <div id="splash-screen" style={{backgroundImage: 'url(/assets/img/splash-screen.jpg)'}}>
            <img src="/assets/img/logo-white.png" alt="پتروماه" />
        </div>
    )
}

export default SplashScreen